import { render, staticRenderFns } from "./Oosterweel.vue?vue&type=template&id=b61ed108&"
import script from "./Oosterweel.vue?vue&type=script&lang=ts&"
export * from "./Oosterweel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports